export default class transition {
    constructor(manager,top) {

        //manager
        this.manager = manager;
        this.sceneManager = top;

    }
    init(){
        TweenMax.set(this.sceneManager.$title,{
            opacity:0,
        });
        for(let i in this.sceneManager.$coverList) {
            if (this.sceneManager.$coverList[i].nodeType != 1) continue;
            TweenMax.set(this.sceneManager.$coverList[i],{
                x:'0%'
            });
        }
    }
    out(){

        TweenMax.to(['#l-scroll',this.sceneManager.$title],1.6,{
            opacity:0,
            ease:this.manager.ease,
        });

    }
    in() {

        TweenMax.to(this.sceneManager.$title,.8,{
            delay:.5,
            opacity:1,
            ease:this.manager.ease,
            onComplete: () => {
                this.set();
            }
        });

    }
    set() { //スクロール一位置よって要素表示

        for(let i in this.manager.scroll.contents.point){

            if(this.manager.scroll.contents.point[i].start<this.manager.scroll.inc+window.innerHeight/2){

                if(this.manager.scroll.contents.status.show[i]) continue;
                this.manager.scroll.contents.status.show[i] = true;
                setTimeout(()=> {
                    if (this.manager.scroll.contents.$show[i]) this.manager.effect.show(this.manager.scroll.contents.$show[i], "show");
                },i * 150);

            }
        }

    }
}